import { create } from 'zustand'

export type TRInfoBase = {
  schoolId: string
  batchId: string
}

export type TRInfo = TRInfoBase[]

export type TRState = { [tankId: string]: TRInfo }

type TRStore = {
  tankRelations: TRState
  setTankRelations: (relations: TRState) => void
}

export const useTankRelationStore = create<TRStore>((set) => ({
  tankRelations: {},
  setTankRelations: (relations) => {
    set(() => ({ tankRelations: relations }))
  },
}))
